import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import { ReactComponent as EmptyBox } from '../../../../assets/svg/empty-box.svg';

interface Props {
  text?: string;
  showSpacing?: boolean;
  icon?: JSX.Element;
  title?: string;
  textStyle?: any;
  button?: JSX.Element;
}

export const EmptyPanel: FC<Props> = ({
  text,
  showSpacing,
  icon,
  title,
  textStyle,
  button,
}) => (
  <Box
    className={classNames('flex flex-col items-center justify-center gap-5', {
      'my-10': showSpacing,
    })}
  >
    {icon || <EmptyBox />}
    <Box flexDirection="column" gap={2} maxWidth={300}>
      {title && (
        <Typography
          variant="body1"
          fontFamily="CircularStdBlack"
          textAlign="center"
        >
          {title}
        </Typography>
      )}
      <Typography
        variant="body1"
        textAlign="center"
        color="var(--text-2)"
        style={textStyle}
      >
        {text || 'No Items Found'}
      </Typography>
    </Box>

    {button}
  </Box>
);
